import { useRef } from 'react';
import { cn } from '@/lib/utils';

/**
 * Card that tracks the cursor with a soft radial highlight, inspired by the
 * "spotlight card" pattern (21st.dev). Driven by CSS custom properties
 * rather than React state so the mousemove handler never triggers a
 * re-render -- see .spotlight-card in index.css for the actual gradient.
 * Uses the brass accent color per the brand's "sparingly, single-point
 * emphasis only" rule, not the neon glows the pattern usually ships with.
 */
const SpotlightCard = ({ as: Tag = 'div', className, children, ...props }) => {
  const ref = useRef(null);

  const handleMouseMove = (e) => {
    const el = ref.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    el.style.setProperty('--spotlight-x', `${e.clientX - rect.left}px`);
    el.style.setProperty('--spotlight-y', `${e.clientY - rect.top}px`);
  };

  return (
    <Tag
      ref={ref}
      onMouseMove={handleMouseMove}
      className={cn('spotlight-card', className)}
      {...props}
    >
      {children}
    </Tag>
  );
};

export default SpotlightCard;
